export default __webpack_public_path__ + "static/media/google.c8ddfd9d.svg";